export class TvSettingsAdapter {
    constructor() {
        this.initialSettings = {};
    }
    setValue(key, value) {
        this.initialSettings[key] = value;
    }
    removeValue(key) {
        if (this.initialSettings.hasOwnProperty(key)) {
            delete this.initialSettings[key];
        }
    }
    clear() {
        this.initialSettings = {};
    }
}
